__turbopack_context__.v({
  "comingSoonBadge": "index-module__0oMSAG__comingSoonBadge",
  "contactUs": "index-module__0oMSAG__contactUs",
  "contactUsDescription": "index-module__0oMSAG__contactUsDescription",
  "contactUsTitle": "index-module__0oMSAG__contactUsTitle",
  "content": "index-module__0oMSAG__content",
  "ctaSection": "index-module__0oMSAG__ctaSection",
  "feature": "index-module__0oMSAG__feature",
  "featureDescription": "index-module__0oMSAG__featureDescription",
  "featureImage": "index-module__0oMSAG__featureImage",
  "featureTitle": "index-module__0oMSAG__featureTitle",
  "features": "index-module__0oMSAG__features",
  "featuresContainer": "index-module__0oMSAG__featuresContainer",
  "featuresDescription": "index-module__0oMSAG__featuresDescription",
  "featuresTitle": "index-module__0oMSAG__featuresTitle",
  "footer": "index-module__0oMSAG__footer",
  "footerBottom": "index-module__0oMSAG__footerBottom",
  "footerHeading": "index-module__0oMSAG__footerHeading",
  "footerLink": "index-module__0oMSAG__footerLink",
  "footerLinkDisabled": "index-module__0oMSAG__footerLinkDisabled",
  "footerLinkSmall": "index-module__0oMSAG__footerLinkSmall",
  "glass-effect": "index-module__0oMSAG__glass-effect",
  "gradient-text": "index-module__0oMSAG__gradient-text",
  "gradientMovement": "index-module__0oMSAG__gradientMovement",
  "gradientText": "index-module__0oMSAG__gradientText",
  "heroSection": "index-module__0oMSAG__heroSection",
  "home": "index-module__0oMSAG__home",
  "mockup-window": "index-module__0oMSAG__mockup-window",
  "overlay": "index-module__0oMSAG__overlay",
  "pricing": "index-module__0oMSAG__pricing",
  "pricingButton": "index-module__0oMSAG__pricingButton",
  "pricingCard": "index-module__0oMSAG__pricingCard",
  "pricingCta": "index-module__0oMSAG__pricingCta",
  "pricingDescription": "index-module__0oMSAG__pricingDescription",
  "pricingFeatureIcon": "index-module__0oMSAG__pricingFeatureIcon",
  "pricingFeatureItem": "index-module__0oMSAG__pricingFeatureItem",
  "pricingFeatures": "index-module__0oMSAG__pricingFeatures",
  "pricingFeaturesList": "index-module__0oMSAG__pricingFeaturesList",
  "pricingHeader": "index-module__0oMSAG__pricingHeader",
  "pricingName": "index-module__0oMSAG__pricingName",
  "pricingPeriod": "index-module__0oMSAG__pricingPeriod",
  "pricingPrice": "index-module__0oMSAG__pricingPrice",
  "pricingTitle": "index-module__0oMSAG__pricingTitle",
  "section": "index-module__0oMSAG__section",
  "socialIconWrapper": "index-module__0oMSAG__socialIconWrapper",
  "socialLink": "index-module__0oMSAG__socialLink",
  "socialLinks": "index-module__0oMSAG__socialLinks",
  "socialSvgIcon": "index-module__0oMSAG__socialSvgIcon",
  "testimonials": "index-module__0oMSAG__testimonials",
  "testimonialsContainer": "index-module__0oMSAG__testimonialsContainer",
  "testimonialsDescription": "index-module__0oMSAG__testimonialsDescription",
  "testimonialsTitle": "index-module__0oMSAG__testimonialsTitle",
});
